module.exports = __webpack_public_path__ + "images/thumb-bf672aa7a87726a9285981cf4a92bcd4.jpg";